import { useState, useEffect } from "react";
import styles from "./CookieBanner.module.scss";

const COOKIE_BANNER_KEY = "cookieBannerDismissed";

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if the banner was previously dismissed
    const isDismissed = localStorage.getItem(COOKIE_BANNER_KEY);
    if (!isDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    // Save to localStorage
    localStorage.setItem(COOKIE_BANNER_KEY, "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className={styles.cookieBanner}>
      <div className={styles.content}>
        <div className={styles.textContent}>
          <h3 className={styles.title}>We Value Your Privacy</h3>
          <p className={styles.text}>
            We use cookies to understand how many people visit our site. We
            don't run ads or sell your data—ever.
          </p>
        </div>
        <div className={styles.buttons}>
          <button className={styles.button} onClick={handleDismiss}>
            Accept Necessary
          </button>
          <button className={styles.button} onClick={handleDismiss}>
            Reject All
          </button>
        </div>
      </div>
    </div>
  );
}
